import { Grid, Typography, Box, TextField, Button } from "@mui/material";
import * as React from "react";
import RobotStatsGrid from "../../../../components/robotStatsEventGrid";
import { useState, useEffect, useRef } from "react";
import { useGlobal } from "../../../../context/GlobalProvider";
import { ScatterPlot } from "../../../../components/analysis/eventGraphs";

export default function OverviewPage({ event, teams }) {
  const scatterRef = useRef(null);
  const { eventList } = useGlobal();

  const eventInfo = eventList.find((e) => e.value === event);
  const [numMatches, setNumMatches] = useState(5);
  const [widths, setWidths] = useState({});
  const [usingEvent, setUsingEvent] = useState(true);

  const handlePastMatchesChange = (change) => {
    setNumMatches(change);
  };
  useEffect(() => {
    handlePastMatchesChange(5);
    const updateWidths = () =>
      setWidths({
        scatterWidth: scatterRef.current?.offsetWidth,
      });
    updateWidths();
  }, []);

  return (
    <Grid container sx={{ display: "flex", mt: 3, width: "100%" }}>
      <Grid item xs={12} sm={8}>
        <Typography
          sx={{ textAlign: { xs: "center", sm: "left" }, fontSize: "10vw" }}
        >
          <b>{eventInfo.eventCode.toUpperCase()}</b>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
          <TextField
            label="Number of Matches Back"
            variant="filled"
            type="number"
            sx={{ width: "100%" }}
            onBlur={(e) => handlePastMatchesChange(e.target.value)}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          <Button
            variant="contained"
            sx={{ width: "100%" }}
            onClick={() => setUsingEvent(!usingEvent)}
          >
            {usingEvent ? event : "All Events"}
          </Button>
        </Box>
      </Grid>
      <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
            width: "100%",
            borderColor: "#daa64b",
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: 3,
            p: { xs: 0, sm: 1 },
          }}
        >
          <RobotStatsGrid
            teams={teams}
            numOfPreviousMatches={numMatches}
            event={usingEvent ? event : ""}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sx={{ width: "100%", justifyItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            width: { xs: "100%", sm: "100%" },
          }}
        >
          <ScatterPlot width={600} data={[]} />
        </Box>
      </Grid>
    </Grid>
  );
}
